const userConstants = {
  LOGIN_REQUEST: 'USER_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USER_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USER_LOGIN_FAILURE',

  GOOGLE_LOGIN_REQUEST: 'GOOGLE_LOGIN_REQUEST',
  GOOGLE_LOGIN_SUCCESS: 'GOOGLE_LOGIN_SUCCESS',
  GOOGLE_LOGIN_FAILURE: 'GOOGLE_LOGIN_FAILURE',

  REGISTER_REQUEST: 'USER_SIGNUP_REQUEST',
  REGISTER_SUCCESS: 'USER_SIGNUP_SUCCESS',
  REGISTER_FAILURE: 'USER_SIGNUP_FAILURE',

  CREATE_COMPANY_REQUEST: 'USER_CREATE_COMPANY_REQUEST',
  CREATE_COMPANY_SUCCESS: 'USER_CREATE_COMPANY_SUCCESS',
  CREATE_COMPANY_FAILURE: 'USER_CREATE_COMPANY_FAILURE',

  GET_COMPANY_REQUEST: 'USER_GET_COMPANY_REQUEST',
  GET_COMPANY_SUCCESS: 'USER_GET_COMPANY_SUCCESS',
  GET_COMPANY_FAILURE: 'USER_GET_COMPANY_FAILURE',

  REGISTER_CONFIRM_REQUEST: 'USER_REGISTER_CONFIRM_REQUEST',
  REGISTER_CONFIRM_SUCCESS: 'USER_REGISTER_CONFIRM_SUCCESS',
  REGISTER_CONFIRM_FAILURE: 'USER_REGISTER_CONFIRM_FAILURE',
  REGISTER_CONFIRM_CLEAR: 'USER_REGISTER_CONFIRM_CLEAR',

  FORGOT_REQUEST: 'USER_FORGOT_REQUEST',
  FORGOT_SUCCESS: 'USER_FORGOT_SUCCESS',
  FORGOT_FAILURE: 'USER_FORGOT_FAILURE',

  RESET_REQUEST: 'USER_RESET_REQUEST',
  RESET_SUCCESS: 'USER_RESET_SUCCESS',
  RESET_FAILURE: 'USER_RESET_FAILURE',

  LOGOUT: 'USER_LOGOUT',

  GET_REQUEST: 'USER_GET_REQUEST',
  GET_SUCCESS: 'USER_GET_SUCCESS',
  GET_FAILURE: 'USER_GET_FAILURE',

  GET_ALL_REQUEST: 'USER_GET_ALL_REQUEST',
  GET_ALL_SUCCESS: 'USER_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'USER_GET_ALL_FAILURE',

  UPDATE_REQUEST: 'USER_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'USER_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'USER_UPDATE_FAILURE',

  GETALL_REQUEST: 'USER_GETALL_REQUEST',
  GETALL_SUCCESS: 'USER_GETALL_SUCCESS',
  GETALL_FAILURE: 'USER_GETALL_FAILURE',

  CREATE_REQUEST: 'USER_CREATE_REQUEST',
  CREATE_SUCCESS: 'USER_CREATE_SUCCESS',
  CREATE_FAILURE: 'USER_CREATE_FAILURE',

  CREATE_BULK_REQUEST: 'USER_CREATE_BULK_REQUEST',
  CREATE_BULK_SUCCESS: 'USER_CREATE_BULK_SUCCESS',
  CREATE_BULK_FAILURE: 'USER_CREATE_BULK_FAILURE',

  CONFIRM_CREATE_BULK_REQUEST: 'USER_CONFIRM_CREATE_BULK_REQUEST',
  CONFIRM_CREATE_BULK_SUCCESS: 'USER_CONFIRM_CREATE_BULK_SUCCESS',
  CONFIRM_CREATE_BULK_FAILURE: 'USER_CONFIRM_CREATE_BULK_FAILURE',

  DELETE_REQUEST: 'USER_DELETE_REQUEST',
  DELETE_SUCCESS: 'USER_DELETE_SUCCESS',
  DELETE_FAILURE: 'USER_DELETE_FAILURE',

  UPDATE_PASSWORD_REQUEST: 'USER_UPDATE_PASSWORD_REQUEST',
  UPDATE_PASSWORD_SUCCESS: 'USER_UPDATE_PASSWORD_SUCCESS',
  UPDATE_PASSWORD_FAILURE: 'USER_UPDATE_PASSWORD_FAILURE',

  UPDATE_MUST_CHANGE_PASSWORD_SUCCESS: 'USER_UPDATE_MUST_CHANGE_PASSWORD_SUCCESS',

  UPDATE_FIRST_LOGIN_SUCCESS: 'USER_UPDATE_FIRST_LOGIN_SUCCESS',
  UPDATE_TUTORIAL_COMPLETE: 'UPDATE_TUTORIAL_COMPLETE'
};

export default userConstants;
